import React from 'react'
import PageTitle from '../../components/PageTitle'

function AddResult() {
  return (
    <div>
       <PageTitle title="Add Result" />
       <img src="\Result-vec.svg" alt="" height={100} width={100} className='my-2'/>
       
    </div>
  )
}

export default AddResult